import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Wrapper, SectionWrapper, LinksWrapper } from './style';
import * as UIActions from '../../../redux/actions/UI';

const NavItems = ({ itemList, toggleGralBKdrop, setSidebarState }) => {
  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    const vpWidth = window.innerWidth;
    if (vpWidth <= 767) {
      toggleGralBKdrop(false);
      setSidebarState(false);
    }
  };
  const content = itemList.map(({ title, items }) => (
    <SectionWrapper>
      <h1>{title}</h1>
      {items.map(({ item, route = '/' }) => (
        <LinksWrapper>
          <NavLink to={route} activeClassName="ActiveLink" key={route} onClick={handleClick}>
            {item}
          </NavLink>
        </LinksWrapper>
      ))}
    </SectionWrapper>
  ));

  return <Wrapper>{content}</Wrapper>;
};

const mapStateToProps = ({ UI }) => ({
  backdropState: UI.showBkDrop,
  sidebarState: UI.sidebarState,
});

const mapDispatchToProps = dispatch => ({
  toggleGralBKdrop: state => dispatch(UIActions.setBKDrop(state)),
  setSidebarState: state => dispatch(UIActions.setSidebarState(state)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavItems);
